enum PageName {
  'Capítulos e Cenas' = 'CC',
  'Planejamento de Roteiros' = 'PR',
  'Roteiros da Semana' = 'RS',
  'Fotos' = 'FT',
  'E-Prod' = 'EP',
  'Relatórios' = 'RL',
  'Decupagem de Continuidade' = 'DC',
  'Decupagem de Arte' = 'DA',
  'Decupagem de Efeitos Especiais' = 'DEE',
  'Indisponibilidade de Elenco' = 'IE',
  'Visões' = 'VS',
  'Decupagem Básica' = 'DB',
  'Decupagem de Figurino' = 'DF',
  'Indicadores' = 'ID',
}

enum PageCode {
  CC = 'Capítulos e Cenas',
  PR = 'Planejamento de Roteiros',
  RS = 'Roteiros da Semana',
  FT = 'Fotos',
  EP = 'E-Prod',
  RL = 'Relatórios',
  DC = 'Decupagem de Continuidade',
  DA = 'Decupagem de Arte',
  DEE = 'Decupagem de Efeitos Especiais',
  IE = 'Indisponibilidade de Elenco',
  VS = 'Visões',
  DB = 'Decupagem Básica',
  DF = 'Decupagem de Figurino',
  ID = 'Indicadores',
}

export { PageName, PageCode };
